import { render } from "./OuraAnalisis.vue?vue&type=template&id=0671329a&scoped=true"
import script from "./OuraAnalisis.vue?vue&type=script&lang=js"
export * from "./OuraAnalisis.vue?vue&type=script&lang=js"

import "./OuraAnalisis.vue?vue&type=style&index=0&id=0671329a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0671329a"]])

export default __exports__